import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { AcuityEmbed } from "@/components/site/AcuityEmbed";
import { AcuityConversionListener } from "@/components/site/AcuityConversionListener";

export const Route = createFileRoute("/schedule-a-consult/virtual")({
  head: () => ({
    meta: [
      { name: "robots", content: "noindex, follow" },
      { title: "Schedule FREE Virtual Hair Transplant Consultation" },
      {
        name: "description",
        content:
          "Schedule your free hair restoration consult with RESTORE hair!. We offer virtual consultations to our clients. Our client advisors will answer your questions.",
      },
      {
        property: "og:title",
        content: "Schedule FREE Virtual Hair Transplant Consultation",
      },
      {
        property: "og:description",
        content:
          "Book a free virtual hair restoration consultation with RESTORE. Our client advisors will answer all your questions.",
      },
      { property: "og:type", content: "website" },
      {
        property: "og:url",
        content: "https://restorehair.com/schedule-a-consult/virtual/",
      },
      { name: "twitter:card", content: "summary" },
    ],
    links: [
      {
        rel: "canonical",
        href: "https://restorehair.com/schedule-a-consult/virtual/",
      },
    ],
  }),
  component: ScheduleVirtualPage,
});

function ScheduleVirtualPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="mx-auto max-w-5xl px-4 py-10 md:py-14">
        <h1 className="text-center text-3xl font-normal text-foreground md:text-5xl">
          Schedule Your <strong className="font-extrabold">FREE</strong> Hair Consultation
        </h1>
        <p className="mt-4 text-center text-base text-muted-foreground md:text-lg">
          Select a time for a free virtual hair transplant consultation
        </p>
        <AcuityConversionListener />
        <div className="mt-8">
          <AcuityEmbed src="https://app.acuityscheduling.com/schedule.php?owner=24213130&owner=24213130&appointmentType=26951951" />
        </div>
      </main>
      <Footer />
    </div>
  );
}
